import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { saveUserChoice } from "../services/storageService";
import api from "../services/api";
import "./SignupPage.css";

export default function SignupPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const ref = queryParams.get("ref"); // Sponsor link if user

  const [isAdminMode, setIsAdminMode] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    bitcoinAddresses: [""],
    maintenanceAddress: "",
  });

  useEffect(() => {
    async function checkAdmin() {
      try {
        const res = await api.get("/auth/admin-exists");
        setIsAdminMode(!res.data.exists);
      } catch (err) {
        setIsAdminMode(false);
      }
    }
    checkAdmin();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleBtcChange = (index, value) => {
    const updated = [...form.bitcoinAddresses];
    updated[index] = value;
    setForm({ ...form, bitcoinAddresses: updated });
  };

  const addBtcField = () => {
    setForm({ ...form, bitcoinAddresses: [...form.bitcoinAddresses, ""] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (isAdminMode) {
        await api.post("/auth/signup-admin", {
          name: form.name,
          email: form.email,
          password: form.password,
          bitcoinAddresses: form.bitcoinAddresses,
          maintenanceAddress: form.maintenanceAddress,
        });
      } else {
        if (!ref) {
          alert("A valid promotion link is required to sign up.");
          return;
        }
        await api.post("/auth/signup", {
          name: form.name,
          email: form.email,
          password: form.password,
          bitcoinAddress: form.bitcoinAddresses[0],
          sponsorId: ref,
        });
      }

      saveUserChoice({ email: form.email });
      navigate("/dashboard");
    } catch (err) {
      alert("Signup failed. Please try again.");
    }
  };

  return (
    <div className="signup-container">
      <h2 className="signup-title">
        {isAdminMode ? "Admin Setup" : "Create Account"}
      </h2>

      <form className="signup-form" onSubmit={handleSubmit}>
        <input
          className="signup-input"
          type="text"
          name="name"
          placeholder="Full Name"
          value={form.name}
          onChange={handleChange}
          required
          autoComplete="name"
        />
        <input
          className="signup-input"
          type="email"
          name="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          required
          autoComplete="email"
        />
        <input
          className="signup-input"
          type="password"
          name="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
          required
          autoComplete="new-password"
        />

        {isAdminMode ? (
          <>
            <h3 style={{margin: "1.1rem 0 0.5rem", color: "#18408b", fontWeight: 600}}>Admin Bitcoin Addresses</h3>
            {form.bitcoinAddresses.map((addr, idx) => (
              <input
                className="signup-input"
                key={idx}
                type="text"
                placeholder={`BTC Address ${idx + 1}`}
                value={addr}
                onChange={(e) => handleBtcChange(idx, e.target.value)}
                required
              />
            ))}
            {form.bitcoinAddresses.length < 8 && (
              <button type="button" onClick={addBtcField} className="signup-btn" style={{marginBottom: "1rem"}}>
                Add Address
              </button>
            )}
            <input
              className="signup-input"
              type="text"
              name="maintenanceAddress"
              placeholder="Maintenance Address"
              value={form.maintenanceAddress}
              onChange={handleChange}
              required
            />
          </>
        ) : (
          <>
            <input
              className="signup-input"
              type="text"
              placeholder="Your BTC Address"
              value={form.bitcoinAddresses[0]}
              onChange={(e) => handleBtcChange(0, e.target.value)}
              required
            />
            <p style={{marginBottom: 0, color: "#444", fontSize: "0.98rem"}}>
              Signing up with sponsor link: <strong style={{color:"#e8a700"}}>{ref || "None"}</strong>
            </p>
          </>
        )}

        <button type="submit" className="signup-btn" style={{marginTop: "1.3rem"}}>
          {isAdminMode ? "Setup Admin" : "Sign Up"}
        </button>
      </form>

      {!isAdminMode && (
        <p className="signup-switch">
          Already have an account?{" "}
          <button
            onClick={() => navigate("/login")}
            className="signup-link-btn"
            aria-label="Go to Login"
            type="button"
          >
            Log in here
          </button>
        </p>
      )}
    </div>
  );
}
